// extracted by mini-css-extract-plugin
export default {"form":"AddBlogForm_form__tr6ki","control":"AddBlogForm_control__9U8RX","actions":"AddBlogForm_actions__zfh+l"};